import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { HttpClient } from '@angular/common/http';
import { InvoiceDocument } from 'src/app/interfaces/invoice-document';
import { ServerTypes } from 'src/app/models/servers';
import { requests } from 'src/app/models/requests';
import { ITollTicketDetail, ITollTickets, IObuDetails, IObjectionDetails } from 'src/app/interfaces/tollticket';
import { DatePipe } from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class ObjectionService {

  constructor(private http: HttpClient, private apiService: ApiService, public date: DatePipe) { }

  private get url(): string {
    return this.apiService.getCurentServer(ServerTypes.ptdesk);
  }

  public getObjectionDetails(invoiceID: string): Observable<IObjectionDetails[]> {
    return this.http.get<IObjectionDetails[]>(
      this.url + `/claims/objections/?idName=invoiceid&id=`+ invoiceID
    );
  }
  public getObjectionDetail(objectionID: string): Observable<IObjectionDetails> {
    return this.http.get<IObjectionDetails>(
      this.url + `/claims/objections/`+ objectionID
    );
  }
  public getObjectionUsers(): any{
    return this.http.get<any>(
     `https://bo-api.epass24.com/v1/workorders/admin/users`)
  }
  public getWorkorderId(objectionID: string): any{
    return this.http.get<any>(
     `https://app-bo-work-westeurope-01.azurewebsites.net/v1/workitems/by-connected-id?idName=objectionI&id=${objectionID}&IncludeBoUsername=true`)
  }
  public postObjectionAction(workItemId, body:any): Observable<any> {
    return this.http.post(`https://app-bo-work-westeurope-01.azurewebsites.net/v1/workitems/${workItemId}/action`, body);
  }
  public postObjectionDocuments(objectionId: string, body: any): Observable<any> {
    return this.http.post(`${this.url}/claims/objections/${objectionId}/correspondence`, body);
  }
  public getObjectionDocuments(objectionId: string): Observable<any> {
    return this.http.get(`${this.url}/claims/objections/${objectionId}/correspondence`);
  }
  public patchObjectionType(objectionId: string, body: any): Observable<any> {
    return this.http.patch(`${this.url}/claims/objections/${objectionId}`,body);
  }


}